import { Component, OnInit } from '@angular/core';

/**
 * EndosigComponent
 * This component is not strong linked to the functionality of ENDOSIG
 */
@Component({
  selector: 'app-endosig',
  templateUrl: './endosig.component.html',
  styleUrls: ['./endosig.component.scss']
})
export class EndosigComponent implements OnInit {
  /**
   * Constructor of component
   */
  constructor() {
  }

  /** Angular Lyfecycle method OnInit */
  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/app/endosig/endosig.component.ts